export const SITE = {
  name: "Manno Auto S.r.l.",
  shortName: "Manno Auto",
  address: "Contrada Lavanghe dell'Oglio, 92011 Cattolica Eraclea (AG)",
  phone: "+39 0922 840435",
  mobile: "+39 380 211 9287",
  whatsapp: "393802119287",
  email: "mannoautosrl@hotmail.it",
  mapsEmbed:
    "https://www.google.com/maps?q=Manno+Auto+S.r.l.,+Cattolica+Eraclea+AG&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Manno+Auto+S.r.l.,+Cattolica+Eraclea+AG",
  reviewLink:
    "https://search.google.com/local/writereview?placeid=ChIJWxkOXqNxGhMRUxuctbUXc1Y",
};

export const BRANDS = [
  "Alfa Romeo", "Audi", "BMW", "Citroën", "Cupra", "Dacia", "DS", "Fiat", "Ford",
  "Honda", "Hyundai", "Jeep", "Kia", "Land Rover", "Mazda", "Mercedes-Benz", "Mini",
  "Nissan", "Opel", "Peugeot", "Porsche", "Renault", "Seat", "Skoda", "Smart",
  "Suzuki", "Toyota", "Volkswagen", "Volvo",
];
export const FUELS = ["Benzina", "Diesel", "Ibrida", "Elettrica", "GPL"];
export const CATEGORIES = ["Nuovo", "Km 0", "Usato Garantito"];
export const PRICE_STEPS = [
  { label: "Fino a € 20.000", value: "20000" },
  { label: "Fino a € 30.000", value: "30000" },
  { label: "Fino a € 50.000", value: "50000" },
  { label: "Fino a € 100.000", value: "100000" },
];

export const HOURS = [
  { d: "Lunedì – Venerdì", h: "09:00 – 13:00 · 15:00 – 19:00" },
  { d: "Sabato", h: "09:00 – 13:00" },
  { d: "Domenica", h: "Chiuso" },
];

export function isOpenNow() {
  const now = new Date();
  const day = now.getDay();
  const t = now.getHours() + now.getMinutes() / 60;
  if (day === 0) return false;
  if (day === 6) return t >= 9 && t < 13;
  return (t >= 9 && t < 13) || (t >= 15 && t < 19);
}

export const waLink = (msg) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

export const fmtPrice = (n) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export const fmtKm = (n) =>
  n === 0 ? "0 km" : `${new Intl.NumberFormat("it-IT").format(n)} km`;

export const HERO_IMG =
  "https://images.pexels.com/photos/28376092/pexels-photo-28376092.jpeg?auto=compress&cs=tinysrgb&w=1600";
export const SHOWROOM_IMG =
  "https://images.pexels.com/photos/5050535/pexels-photo-5050535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const INTERIOR_IMG =
  "https://images.unsplash.com/photo-1542834506-979b3951bc9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjYXIlMjBzdGVlcmluZyUyMHdoZWVsJTIwZGFzaGJvYXJkJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3OTAwMDI2OTJ8MA&ixlib=rb-4.1.0&q=85";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
